import React from "react";

/**
 * ChromeOverlays
 * --------------
 * The status bar, notch/Dynamic Island, and home indicator that sit on top of the
 * platform chrome inside the device screen. Kept platform-agnostic: light iOS status
 * bar + Dynamic Island + home indicator. Agent C's per-platform variants supply the
 * platform-branded header and tab bar separately.
 *
 * Props:
 *   - platform: forwarded for future use (dark-mode toggles, etc.).
 *   - postType: forwarded for future use (full-screen Reels hide the status bar).
 *   - time:     override the status-bar clock (default "9:41").
 */
export default function ChromeOverlays({ platform, postType, time = "9:41" }) {
  const isFullScreen = postType === "Reel" || postType === "Story" || postType === "Short";

  return (
    <>
      {/* Status bar — hidden for full-screen post types per spec 4.2/4.3 */}
      {!isFullScreen ? (
        <div
          className="vella-chrome-status-bar"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 28px 4px",
            fontSize: 12,
            fontWeight: 600,
            color: "#000",
            zIndex: 20,
            pointerEvents: "none",
          }}
        >
          <span>{time}</span>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3a4.237 4.237 0 00-6 0zm-4-4l2 2a7.074 7.074 0 0110 0l2-2C15.14 9.14 8.87 9.14 5 13z" />
            </svg>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z" />
            </svg>
          </div>
        </div>
      ) : null}

      {/* Dynamic Island / notch */}
      <div
        aria-hidden
        className="vella-chrome-dynamic-island"
        style={{
          position: "absolute",
          top: 8,
          left: "50%",
          transform: "translateX(-50%)",
          background: "#000",
          borderRadius: 9999,
          width: 100,
          height: 26,
          zIndex: 25,
          pointerEvents: "none",
        }}
      />

      {/* Home indicator */}
      <div
        aria-hidden
        className="vella-chrome-home-indicator"
        style={{
          position: "absolute",
          bottom: 6,
          left: "50%",
          transform: "translateX(-50%)",
          width: 120,
          height: 4,
          background: "#000",
          borderRadius: 9999,
          opacity: 0.4,
          zIndex: 20,
          pointerEvents: "none",
        }}
        data-platform={platform || undefined}
      />
    </>
  );
}
